import React, {ReactNode} from "react"
import styled from "styled-components"
import {Team, TeamState} from "@irati/types"
import FormattedMessage from "@irati/utils/lang"
import teamNameHelper from "@irati/identity/utils/team/teamName"

const StyledTeamType = styled.span`
  margin-left: 5px;
`

interface Props {
  team?: Team
  postFixType?: boolean
}

const TeamName: React.FC<Props> = ({team, ...props}) => {
  const postFixType = props.postFixType ?? false
  let teamName: ReactNode = teamNameHelper(team)
  let postFix

  if (team) {
    teamName = <span>{teamName}</span>
    if (team.teamState === TeamState.BillingUnit) {
      teamName = team.teamName.replace("platform.billingUnit.", "")
      postFix = (
        <StyledTeamType>
          (<FormattedMessage id="platform.billing.teamType.billingUnit" />)
        </StyledTeamType>
      )
    }

    if (team.teamState === TeamState.Protected) {
      postFix = (
        <StyledTeamType>
          (<FormattedMessage id="platform.billing.teamType.protectedTeam" />)
        </StyledTeamType>
      )
    }
  }

  return (
    <>
      {teamName}
      {postFixType && postFix}
    </>
  )
}

export default TeamName
